import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { ROUTES } from '@constants/index'
import { useAppNavigate } from '@hooks/useAppNavigate'
import { usePathBuilder } from '@hooks/usePathBuilder'
import { showApp, appErrorSelector, setAppVisibleAllowed } from '@redux/slices/workflowSlice'

export const useAppErrorHandler = () => {
  const buildPath = usePathBuilder()
  const navigate = useAppNavigate()
  const dispatch = useDispatch()
  const error = useSelector(appErrorSelector)

  useEffect(() => {
    if (error?.errorType) {
      setAppVisibleAllowed()
      dispatch(showApp())
      navigate(buildPath(ROUTES.ERROR), { state: { errorType: error.errorType } })
    }
  }, [dispatch, buildPath, navigate, error])
}
